import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "date-range-selector" }
const _hoisted_2 = { style: {"text-align":"left"} }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "date-range-selector__label d-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_load = _resolveComponent("load")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_load, {
      loaded: _ctx.loading,
      name: "date",
      information: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_date_picker, {
          value: _ctx.dateTime,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateTime) = $event)),
          range: "",
          format: "DD/MMMM/YYYY",
          "range-separator": " a ",
          placeholder: "Selecionar Período",
          "disabled-date": (date) => date >= new Date(),
          clearable: false,
          onPick: _ctx.pickingData
        }, {
          sidebar: _withCtx(({ emit }) => [
            _createElementVNode("div", _hoisted_2, [
              _cache[2] || (_cache[2] = _createElementVNode("p", null, "Selecione um período", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datePeriodOptions, (period, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: index,
                  class: "mx-btn mx-btn-text d-flex align-items-center",
                  onClick: ($event: any) => (_ctx.selectPeriod(emit, period.numberOfDays))
                }, [
                  _cache[1] || (_cache[1] = _createElementVNode("i", { class: "icon-nav-bullet_right arrow-date-picker" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(period.label), 1)
                ], 8, _hoisted_3))
              }), 128))
            ])
          ]),
          "icon-calendar": _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "icon-nav-bullet_down date-range-selector__icon" }, null, -1)
          ])),
          input: _withCtx((data) => [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.getLabel(data.value)), 1)
          ]),
          _: 1
        }, 8, ["value", "disabled-date", "onPick"])
      ]),
      _: 1
    }, 8, ["loaded"])
  ]))
}